export const DEFAULT_SEARCH_PAGE_SIZE = 25;
export const DEFAULT_SEARCH_MODAL_SIZE = 10;
export const DEFAULT_SEARCH_OVERVIEW_SIZE = 3;
